import { getQueryKeys } from "../../helper";

const namespace = "payments/banks/country";

export default {
  ...getQueryKeys(namespace),
};
